<script setup lang="ts">
const props = defineProps<{
  vertical?: "top" | "bottom";
  horizontal?: "start" | "end";
}>();

provide(
  "vertical",
  computed(() => props.vertical)
);

provide(
  "horizontal",
  computed(() => props.horizontal)
);

const { isMobile, isTouch } = useUserDevice();
</script>

<template>
  <div
    :class="[
      'content-image-actions',
      `content-image-actions--${vertical}`,
      `content-image-actions--${horizontal}`,

      'transition-opacity duration-500',
      isMobile || isTouch
        ? 'opacity-100'
        : 'lg:opacity-0 lg:group-hover/image:opacity-100 lg:group-focus-within/image:opacity-100',

      'absolute',
      'flex items-center gap-4',
      'p-4',

      {
        'top-0': vertical === 'top',
        'bottom-0': vertical === 'bottom',
        'start-0': horizontal === 'start',
        'end-0': horizontal === 'end',
      },
    ]"
  >
    <div class="content-image-actions__wrapper flex items-center gap-4">
      <slot v-bind="{ vertical, horizontal }" />
    </div>
  </div>
</template>
